const myNav = document.querySelector('.navbar-top');
const sections = document.querySelectorAll('.change-nav-color');

function checkNavBg() {
  let inSection = false;

  sections.forEach(section => {
    const sectionTop = section.offsetTop;
    const sectionBottom = sectionTop + section.offsetHeight;
    const scrollY = window.scrollY;

    // Vérifie si on est dans la section ou si on est au-dessus (pour cas "hero" en fond bleu)
    if (scrollY >= sectionTop && scrollY < sectionBottom) {
      inSection = true;
    }
  });

  if (inSection) {
    myNav.classList.add('bg-change');
  } else {
    myNav.classList.remove('bg-change');
  }
}

// Vérifie au chargement
window.addEventListener('load', checkNavBg);

// Vérifie au scroll
window.addEventListener('scroll', checkNavBg);
